module.exports = __webpack_public_path__ + "static/media/teacher.969f65ab.png";